import _ from 'lodash';

export default function checkProfile(user, props) {
  const {
    userAges,
    userActivityTypes,
    userExpertises,
    userSubjects,
    userGrades,
    isEducator,
    isPartner
  } = props;

  /*
   * 6 educator required fields:
   * first name
   * last name
   * bio
   * zip code
   * age groups
   * subject areas
   *
   * 7 partner required fields:
   * first name
   * last name
   * bio
   * zip code
   * age groups
   * activity types
   * expertise areas
   */

  const profile = {
    fields: []
  };

  const interests = {
    fields: []
  };

  if (!user.data.firstName) {
    profile.fields.push({
      column: 'firstName',
      name: 'first name',
      label: 'First name'
    });
  }

  if (!user.data.lastName) {
    profile.fields.push({
      column: 'lastName',
      name: 'last name',
      label: 'Last name'
    });
  }

  // if (
  //   isPartner &&
  //   !user.data.biography
  // ) {
  //   profile.fields.push({
  //     column: 'biography',
  //     name: 'biography',
  //     label: 'Biography'
  //   });
  // }

  // optional
  // if (!user.data.gender) {
  //   profile.fields.push({
  //     column: 'gender',
  //     label: 'Gender'
  //   });
  // }
  //
  // if (!user.data.ethnicity) {
  //   profile.fields.push({
  //     column: 'ethnicity',
  //     label: 'Ethnicity'
  //   });
  // }
  //
  // if (!user.data.yearOfBirth) {
  //   profile.fields.push({
  //     column: 'yearOfBirth',
  //     label: 'Year of birth'
  //   });
  // }

  if (!user.data.zipCode) {
    profile.fields.push({
      column: 'zipCode',
      name: 'zip code',
      label: 'Zip code'
    });
  }

  // if (
  //   isEducator &&
  //   userGrades.data.length < 1
  // ) {
  //   interests.fields.push({
  //     column: 'grades',
  //     name: 'grade levels',
  //     // label: 'At least one grade level'
  //     label: 'Grade level'
  //   });
  // }

  // if (
  //   isEducator &&
  //   userSubjects.data.length < 1
  // ) {
  //   interests.fields.push({
  //     column: 'subjects',
  //     name: 'subject areas',
  //     // label: 'At least one subject area'
  //     label: 'Subject area'
  //   });
  // }

  // if (
  //   isPartner &&
  //   userAges.data.length < 1
  // ) {
  //   interests.fields.push({
  //     column: 'ages',
  //     name: 'age groups',
  //     // label: 'At least one age group'
  //     label: 'Age group'
  //   });
  // }

  // if (
  //   isPartner &&
  //   userActivityTypes.data.length < 1
  // ) {
  //   interests.fields.push({
  //     column: 'activityTypes',
  //     name: 'activity types',
  //     // label: 'At least one engagement type'
  //     label: 'Engagement type'
  //   });
  // }

  if (
    isPartner &&
    userExpertises.data.length < 1
  ) {
    interests.fields.push({
      column: 'expertises',
      name: 'expertise areas',
      // label: 'At least one expertise area'
      label: 'Expertise area'
    });
  }

  return {
    profile: profile.fields,
    interests: interests.fields
  };
};
